import { render, staticRenderFns } from "./PaletteMenuItem.vue?vue&type=template&id=bb14a6ba&scoped=true"
import script from "./PaletteMenuItem.vue?vue&type=script&lang=js"
export * from "./PaletteMenuItem.vue?vue&type=script&lang=js"
import style0 from "./PaletteMenuItem.vue?vue&type=style&index=0&id=bb14a6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb14a6ba",
  null
  
)

export default component.exports